
















import { Component, Vue } from 'vue-property-decorator'
import validation from '../../common/element-val'
import auth, { ChangePwdModel } from '../../services/authService'
import { MessageText } from '@/services/data'
import { VForm } from '@/services/VForm'

@Component
export default class ChangePwd extends Vue {
  $refs: {
    pwdForm: VForm;
  }

  isLoading = false
  pwd: ChangePwdModel = {
    OriPassword: '',
    NewPassword: '',
    Confirm: ''
  }

  message: MessageText = null
  rules = {
    required: validation.required(this.$t('val.required') as string)
  }

  async submit () {
    if (this.$refs.pwdForm.validate()) {
      this.isLoading = true
      try {
        const res = await auth.changePwdAsync(this.pwd)
        this.isLoading = false
        if (res.Error) {
          await this.$alert(this.$t('msg.' + res.Error) as string)
        } else {
          await this.$success(this.$t('msg.passwordChanged') as string)
        }
      } catch (e) {
        this.isLoading = false
        this.message = { error: e }
      }
    }
  }
}
